import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { ZzzSecuriteService } from './shared/securite.service';

@Injectable({ providedIn: 'root' })
export class IdzUnauthorizedInterceptor implements HttpInterceptor {

  constructor(
    private securiteService: ZzzSecuriteService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(x => this.handleIdzForbiddenError(x, request)
      ));
  }

  private handleIdzForbiddenError(err: HttpErrorResponse, request: HttpRequest<any>): Observable<any> {
    if ((err.status === 401 || err.status === 403) && request.url.includes("/sigtapi")) {
      localStorage.setItem('SIGT-Error', `Veuillez-vous reconnecter : vous avez été déconnecté ou une modification affectant les droits de l'application a été apportée.`);
      return this.securiteService.deconnecter();
    }
    //Jusqu'à ce que l'on corrige les erreurs 400 des appels d'igo2 dans les contextes.
    if (err.status === 400) {
      return of({});
    }
    throw (err);
  }
}
